import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import store from '@/store';

/**
 * Guard that resets application badge totals when navigating between different applications
 * to prevent showing cached notification badges from the previous application
 */
function applicationsBadgeGuard(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void {
  const isApplicationsRoute = to.path?.includes('/applications') || false;
  const toApplicationUuid = to.params?.application_uuid;
  const fromApplicationUuid = from.params?.application_uuid;
  const isDifferentApplication = toApplicationUuid && fromApplicationUuid && toApplicationUuid !== fromApplicationUuid;
  const isSameJob = to.params?.job_uuid === from.params?.job_uuid;

  if (isApplicationsRoute && isDifferentApplication && isSameJob) {
    store.commit('applications/setReceivedTotal', { applications: { totalCount: 0 } });
    store.commit('applications/setInterestedTotal', { applications: { totalCount: 0 } });
    store.commit('applications/setNotAFitTotal', { applications: { totalCount: 0 } });
  }

  next();
}

export default applicationsBadgeGuard;
